module.exports = __webpack_public_path__ + "static/media/Step1.80394298.png";